import { render, staticRenderFns } from "./ForeCasts.vue?vue&type=template&id=039de235"
import script from "./ForeCasts.vue?vue&type=script&lang=js"
export * from "./ForeCasts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports